import Clear from '@/layouts/Clear.vue';

export default {
  path: '/settings',
  component: Clear,
  children: [
    {
      path: '',
      name: 'settings.index',
      component: () => import('@/views/Settings/Settings.vue'),
    },
  ],
};
